const CheckMark = ({ width = 16, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width={width}
    height={height}
  >
    <path fill="#000" d="M6.5 12 2 7.5l.7-.7 3.8 3.8 6.8-6.8.7.7L6.5 12Z" />
  </svg>
);

export default CheckMark;
